<template>
    <div v-if="form.status !== 1 && form.status !== 4 && form.typ !== 4 && form.foO_DAT != null" class="detail-card yellow">
        <ElectronicInvoice
            v-if="isEInvoiceShow"
            :form="form"
            :isDeleteDateValidate="isDeleteDateValidate"
            @openDiscount="$event => $emit('openDiscount', $event)"
            @openVoid="$event => $emit('openVoid', $event)"
            @reload="$emit('reload')"
            @void="$emit('void')"
        />
        <NormalInvoice v-else
            :form="form"
            :isDeleteDateValidate="isDeleteDateValidate"
            @openDiscount="$event => $emit('openDiscount', $event)"
            @openVoid="$event => $emit('openVoid', $event)"
            @reload="$emit('reload')"
        />
    </div>
</template>

<script>
import moment from 'moment';
import NormalInvoice from '@/components/dashboard/Invoice/InvoiceDetailDialog/InvoiceIssueLayout/NormalInvoice.vue';
import ElectronicInvoice from '@/components/dashboard/Invoice/InvoiceDetailDialog/InvoiceIssueLayout/ElectronicInvoice.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        isEInvoiceShow() {
            // 開立電子發票明細顯示條件
            const HAS_E_INVOICE_SERVICE = this.$store.getters['menu/companyInfo'].eInvoice;
            return HAS_E_INVOICE_SERVICE && !!this.form.e_InvoiceDate;
        },
        isDeleteDateValidate() {
            const CURR_MONTH = moment(this.form.foO_DAT).month() + 1;

            let year = moment(this.form.foO_DAT).year();
            const month = (Math.ceil(CURR_MONTH / 2) * 2 + 1) % 12;
            if (CURR_MONTH > 10) year += 1;

            const DUE_DATE = moment()
                .year(year)
                .month(month - 1)
                .date(15)
                .startOf('day');

            return moment().isBefore(DUE_DATE);
        },
    },
    components: { NormalInvoice, ElectronicInvoice },
};
</script>
